import React from 'react'
import Modal from '@material-ui/core/Modal';
import style from 'style/ModalMenu.css';

class ModalMenu extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      menus: this.props.menus
    }
  }
  handleClose = () => {
    this.setState({ open: false })
  }

  openModal = () => {
    this.setState({ open: true })
  }

  render() {
    return (
      <Modal

        open={this.state.open}
        onClose={this.handleClose}
      >
        <div className="modal-menu">
          {this.state.menus.map(menu => {
            return (
              <div className='menu-row' onClick={menu.fn}>
                {menu.icon}
                <div className='menu-title'> {menu.title}</div>
              </div>
            )
          })}

        </div>
      </Modal>
    )
  }
}
export default ModalMenu